require('slick-carousel');
import WOW from '../../js/pages/client-admin-app/wow.min'
import $ from "jquery";
import {getMode} from "../media";

let $offset = 120;

//console.log('booking solution')

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}

// if($('.faq-section .masonry-grid--item-toggler')){
//     $('.faq-section .masonry-grid--item-toggler').on('click', function (){
//         $(this).toggleClass('--active');
//         $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body').slideToggle();
//     })
// }

if ( $(window).width() < 768) {
    $offset = 70;
} else {
    $offset = 120;
}

new WOW({
    offset: $offset
}).init();


function heroImageCarousel( selector ){
    if( $(selector).length ){
        selector.slick({
            dots: true,
            infinite: false,
            slidesToShow: 1,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            appendDots: $('.bs__carousel-dots')
        });
    }
}



heroImageCarousel( $('.bs__carousel') );




